import React from 'react'

interface StatusCancelledIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusCancelledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusCancelledIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* X mark */}
      <path d="M9 9l6 6" />
      <path d="M15 9l-6 6" />
    </svg>
  )
}
